
export enum LhlpRecordType {
    //NHLE
    NHLE = "nhle",
    //LHLP
    ASSET = "asset",
    LocalListArea = "LocalListArea",
    LocalListSubAreas = "LocalListSubAreas",
} 

export enum LhlpRecordSubType {
    NotSet = "",
    //NHLE
    Battlefield = "Battlefields",
    ListedBuilding = "ListedBuildings",
    RegisteredParkAndGarden = "ParksandGardens",
    ProtectedWreck = "ProtectedWrecks",
    ScheduledMonument = "ScheduledMonuments",
    WorldHeritageSite = "WorldHeritageSites",
    //LHLP
    AssetTypeBuilding = "1",
    AssetTypeParkOrGarden = "2",
    AssetTypeLandmarkOrArtwork = "3",
    AssetTypeOtherSiteStructure = "4",
} 
